import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as campaignListsActions from '../../../redux/actions/CampaignListsActions';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import CampaignListsTable from './CampaignListsTable';
import CreateCampaignListModal from '../campaignsCommon/CreateCampaignListModal';
import { PermissionTypes } from '../../../lib/systemVariables';
import { debounce } from 'throttle-debounce';

class CampaignListsPage extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModals: {
        createCampaignListModal: false
      }
    }
  }

  componentDidMount() {
    if (!this.props.history.location.state || !this.props.history.location.state.preserveData) { //manually reset and reload data, only if not nav from campaign list details page
      this.props.actions.updateCampaignListsSearch(""); //reset search keyword
      this.props.actions.getCampaignLists(); //reload data with default table settings
    } else {
      this.props.actions.getCampaignLists(this.props.campaignListsTable.page, this.props.campaignListsTable.resultView, this.props.campaignListsTable.sort);
      delete this.props.history.location.state.preserveData;
    }
  }

  searchLists = keyword => {
    this.props.actions.updateCampaignListsSearch(keyword);
    this.searchDebounce();
  }

  searchDebounce = debounce(500, () => {
    this.props.actions.getCampaignLists(1, this.props.campaignListsTable.resultView, this.props.campaignListsTable.sort);
  });

  render() {
    return (
      <div className="page campaign-list">
        <div className="subheader campaign-header">
          <div className="container flex-justify">
            <div>
              <h2 className="page-header campaign-lists-header">
                Campaign Lists {this.props.userPermissions.manage &&
                  <span className="btn btn-primary btn-small icon-right" onClick={this.toggleModal.bind(this, "createCampaignListModal")}>Add list</span>}
              </h2>
            </div>
            <div className="back-link">
              <i className="icon ion-android-arrow-back middle medium-text"></i>
              <Link to="/campaigns" className="link-text small-text">Back to Campaigns</Link>
            </div>
          </div>
        </div>

        <div className="campaigns-filters">
          <div className="container flex-center">
            <div className="search-input" >
              <i className="material-icons">search</i>
              <input type="text" placeholder="Search List Names"
                value={this.props.keyword}
                disabled={!this.props.keyword && !this.props.campaignListsTable.data.records.length}
                onChange={e => this.searchLists(e.target.value)} />
            </div>
          </div>
        </div>

        <CampaignListsTable
          {...this.props.campaignListsTable}
          updateTable={this.props.actions.updateTable}
          getCampaignLists={this.props.actions.getCampaignLists} />

        <CreateCampaignListModal
          show={this.state.showModals.createCampaignListModal}
          close={this.toggleModal.bind(this, "createCampaignListModal")}
          {...this.props.newCampaignList}
          isAdmin={this.props.userPermissions.admin}
          individualCategories={this.props.systemSettings.recipientSettings.individualTags.map(indivTag => ({ key: indivTag.key, value: indivTag.value }))}
          organizationCategories={this.props.userPermissions.institutions 
            ? this.props.systemSettings.recipientSettings.organizationTags.map(orgTag => ({ key: orgTag.key, value: orgTag.value }))
            : []}
          locations={this.props.locationGroups || []}
          organizations={this.props.organizations || []}
          ILFunds={this.props.funds.IL || []}
          USFunds={this.props.funds.US || []}
          createCampaignList={this.props.actions.createCampaignList}
          onSuccess={this.pushRoute.bind(this, `/campaigns/lists/${this.props.newCampaignList.campaignListId}`)} />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...state.campaignLists,
    campaignListsTable: state.campaignListsTable,
    systemSettings: state.settings.systemSettings.data,
    locationGroups: state.settings.systemSettings.data.campaignSettings.locationGroups.filter(lg =>
      state.userProfile.profile.data.departments.indexOf(lg.department) >= 0),
    organizations: state.recipientAccounts.organizations.data,
    funds: state.funds.fundsByDept,
    userPermissions: {
      admin: state.userProfile.profile.data.roleId === 1,
      manage: state.userProfile.permissions.data.indexOf(PermissionTypes.CampaignAndListsManage) >= 0,
      institutions: state.userProfile.permissions.data.indexOf(PermissionTypes.InstitutionsManage) >= 0
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(campaignListsActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignListsPage);


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignLists/CampaignListsPage.jsx